export default variantHasOptionValue = ({
  variant,
  optionName,
  optionValue,
}) => {
  if (optionName) {
    return variant.selectedOptions.some(
      (option) => option.name === optionName && option.value === optionValue,
    );
  } else {
    return variant.selectedOptions.some(
      (option) => option.value === optionValue,
    );
  }
};
